import { isPlainObject } from 'lodash-es'

export function assertIsPlainObject<MaybeObject>(
  maybeObject: MaybeObject
): maybeObject is Extract<MaybeObject, Record<string, unknown>> {
  return isPlainObject(maybeObject)
}
